import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../../../commonComponents/forms/FormInput';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import translate from '../../../../commonComponents/translate';

function CareerFilters(props) {
  const { loggedUser } = useContext(LoggedUserContext);
  const { _id: loggedUserId } = loggedUser;
  const { t, filters, onFilterChange } = props;
  const { user } = filters;

  const inputProps = useCallback(
    field => {
      switch (field) {
        case 'user':
          return {
            allowClear: false,
            url: '/user/table/network/list',
            filterUrl: '/user/table/network/list',
            query: { type: 'collaborator' },
          };
        default:
          return {
            items: [],
          };
      }
    },
    [loggedUserId],
  );

  return (
    <div className="filters-wrapper">
      <div className="career-filter-container">
        <FormInput
          id="user"
          value={user}
          name="user"
          disabled={false}
          placeholder={t('user')}
          type="users"
          onChange={onFilterChange('user')}
          inputProps={inputProps('user')}
        />
      </div>
    </div>
  );
}

CareerFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    user: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
  }).isRequired,
};

export default translate(CareerFilters);
